import { atom } from 'recoil';

export const firmPagingAtom = atom<number>({
   key: 'firmPagingAtom',
   default: 0,
});
